import { render, staticRenderFns } from "./NotificationDetailsPopup.vue?vue&type=template&id=2059a8ee"
import script from "./NotificationDetailsPopup.vue?vue&type=script&lang=js"
export * from "./NotificationDetailsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports